import Stack from '@mui/material/Stack';
import { useMemo } from 'react';
import { useFiltersContext } from '../context/FiltersContext.tsx';
import { ClearFiltersButton } from './components/ClearFiltersButton.tsx';
import { FiltersBarScrollableWrapper } from './components/FiltersBarScrollableWrapper.tsx';
import { MoreFilters } from './components/moreFilters/MoreFilters.tsx';
import { SingleFiltersList } from './components/SingleFiltersList.tsx';
import { filterVisibleFilters } from './utils.ts';

export const FiltersBar = <Criteria extends Record<string, string | string[]>>() => {
  const { filtersConfig, visibleFilters } = useFiltersContext<Criteria>();

  const { filteredVisibleFilters, moreFilters } = useMemo(
    () => filterVisibleFilters<Criteria>(filtersConfig, visibleFilters),
    [filtersConfig, visibleFilters]
  );

  return (
    <FiltersBarScrollableWrapper>
      <Stack
        direction="row"
        spacing={1}
        data-test="filters-bar"
        sx={{
          alignItems: 'center',
          paddingLeft: 1,
          paddingRight: 1,
        }}
      >
        <SingleFiltersList filters={filteredVisibleFilters} />

        {moreFilters.length > 0 && <MoreFilters filters={moreFilters} />}
        <ClearFiltersButton />
      </Stack>
    </FiltersBarScrollableWrapper>
  );
};
